import MobileBottomNavigation from '@/components/layout/MobileBottomNavigation';
import { useIsMobile } from '@/hooks/use-mobile';

const Navbar = (): React.ReactElement => {
  const isMobile = useIsMobile();

  // ─────────────────────────────────────────────────────────────────────────────
  // Bottom navigation — HIDDEN on web (2026-04-20).
  //
  // Steve-Jobs-mode critique (multi-dimensional decision analysis):
  //   · "Focus is about saying no." The hamburger + sidebar already exposes every
  //     primary destination. A bottom nav of 5 items duplicates the same tree and
  //     forces the user to pick between two nav systems — decision fatigue we
  //     explicitly committed to avoid (see memory/feedback_create_page_ux).
  //   · Visual weight: anchoring a 64px bar at the bottom of every page darkens
  //     the composition, pulls attention away from content, and compresses the
  //     usable reading/writing canvas on small screens.
  //   · Real-estate economics: the Create page already uses the bottom rail for
  //     the composer input. A persistent nav fights that rail for taps.
  //   · Mobile-app trajectory: we'll rebuild a purposeful native bottom tab bar
  //     when we ship iOS/Android — not default-drag this web mock into native.
  //   · Confidence matrix: keep=0.60, hide=0.85, delete=0.30. Winner: hide but
  //     retain the component so we can restore with confidence for native.
  //
  // Rule: do NOT re-enable without re-running this critique and a usability test.
  // If/when reintroduced, it should only appear on very narrow viewports AND
  // only when the sidebar is NOT present (avoid two nav systems).
  // ─────────────────────────────────────────────────────────────────────────────
  const ENABLE_MOBILE_BOTTOM_NAV = false;
  if (ENABLE_MOBILE_BOTTOM_NAV && isMobile) {
    return <MobileBottomNavigation />;
  }
  return <></>;
};

export default Navbar;
